import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/views/Home.vue'
import ProductDetail from '@/components/ProductDetail.vue'
import CategoryPage from '@/components/CategoryPage.vue'
import AboutPage from '@/components/AboutPage.vue'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home
    },
    {
      path: '/category',
      name: 'Category',
      component: Home   // 仍然用 Home.vue
    },
    {
      path: '/about',
      name: 'About',
      component: Home   // 仍然用 Home.vue
    },
    {
      path: '/product-detail',
      name: 'ProductDetail',
      component: ProductDetail  // 详情页
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js